import script from "./blfrjn.vue?vue&type=script&setup=true&lang=js"
export * from "./blfrjn.vue?vue&type=script&setup=true&lang=js"

import "./blfrjn.vue?vue&type=style&index=0&id=cfca8888&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfca8888"]])

export default __exports__